import ActionModal from '../../../modals/components/actionModal/ActionModal';

import useAds from '../../hooks/useAds';
import deleteAdsThunk from '../../services/thunks/deleteAdsThunk';
import './adsDeleteModal.scss';

const AdsDeleteModal = () => {
  const { selectedAds, pageOrigin, deleteAds } = useAds({
    noLoadAds: true,
    noResetAds: true,
  });
  const qty = selectedAds.length;

  const handleCancel = () => {
    deleteAds(false);
  };

  return (
    <ActionModal
      closeAction={handleCancel}
      validAction={deleteAdsThunk({
        pageOrigin,
      })}
      validText="SUPPRIMER"
      modalType="suppression"
    >
      <p>
        Confirmez-vous la suppression
        {qty > 1
          ? ` des ${qty} annonces sélectionnées `
          : ` de l'annonce sélectionnée `}
        sur votre pige classique et vos recherches actives ?
      </p>
      <p>La suppression sera définitive.</p>
    </ActionModal>
  );
};

export default AdsDeleteModal;
